import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "annualPlans",
    "monthlyPlans",
    "monthlyText",
    "annualText",
    "monthlyTable",
    "annualTable",    
  ];

  toggle() {
    this.monthlyPlansTarget.classList.toggle("premium-card--active");
    this.annualPlansTarget.classList.toggle("premium-card--active");
    this.monthlyTableTarget.classList.toggle("tw-hidden");
    this.annualTableTarget.classList.toggle("tw-hidden");

    this._toggleText(this.monthlyTextTarget);
    this._toggleText(this.annualTextTarget);
  }

  _toggleText(element) {
    if (element.classList.contains("tw-text-gray-400")) {
      element.classList.remove("tw-text-gray-400");
      element.classList.add(
        "tw-text-gray-600",
        "dark:tw-text-gray-300",
        "tw-font-bold",
      );
    } else {
      element.classList.remove(
        "tw-text-gray-600",
        "dark:tw-text-gray-300",
        "tw-font-bold",
      );
      element.classList.add("tw-text-gray-400");
    }
  }
}
